/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_FULL_PAYMENT_USERS = gql`
  query GetUserAdvancedSearch(
    $options: GetManyOptions
    $filter: UserAdvancedSearchFilterInput
  ) {
    getUserAdvancedSearch(options: $options, filter: $filter) {
      content {
        _id

        ReferalUsers {
          email
          role
          fullName
        }
        paymentStats
        User {
          fullName
          email
          _id
        }
        createdAt
        totalAmount
        CostumeType {
          name
        }
        Section {
          name
        }
      }
      count
      skip
      limit
    }
  }
`;
